module.exports = __webpack_public_path__ + "static/media/Flying Warrior.815d48b2.jpg";